import { colorOpacity, pxToRem } from '../../../utils/styles';
import colors from './colors';

export default {
  '1': `0 ${pxToRem(2)} ${pxToRem(4)} ${colorOpacity(colors.black, 0.24)}`,
  '2': `0 ${pxToRem(5)} ${pxToRem(10)} ${colorOpacity(colors.black, 0.16)}`,
  '3': `0 ${pxToRem(10)} ${pxToRem(20)} ${colorOpacity(colors.black, 0.08)}`,
  accent: `0 0 ${pxToRem(40)} ${colorOpacity(colors.brand1, 0.25)}`
};
